module.exports = __webpack_public_path__ + "static/jam1-ba52223e96b8929d96794fd3d5f7a87b.svg";